import React from 'react';
import { Order } from '@Types/cart';
import { AccountDetailsProps } from 'components/commercetools-ui/account/details';
import { useFormat } from 'helpers/hooks/useFormat';
import OrderDetail from '../order-history/order/detail';
import ServiceArea from '../utils/service';

export type GeneralProps = {
  order?: Order;
};

const General: React.FC<AccountDetailsProps & GeneralProps> = ({
  enableBtn,
  buttonText,
  buttonLink,
  linkList,
  order,
}) => {
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });

  return (
    <>
      {order ? (
        <div className="flex flex-col gap-8">
          <div className="font-headline text-xl">{formatAccountMessage({ id: 'my.last.order' })}</div>

          <OrderDetail order={order} />
        </div>
      ) : (
        <>
          <div className="font-headline text-xl">
            {formatAccountMessage({ id: 'welcome', defaultMessage: 'Willkommen in deinem Kundenkonto!' })}
          </div>
          <div className="">{formatAccountMessage({ id: 'welcome.subline' })}</div>
        </>
      )}

      {/* Service area */}
      <ServiceArea enableBtn={enableBtn} buttonText={buttonText} buttonLink={buttonLink} linkList={linkList} />
    </>
  );
};

export default General;
